module.exports = __webpack_public_path__ + "static/media/ca-bobina1.c60930f5.jpg";